import { createFileRoute } from '@tanstack/react-router'
import { BrowserGatePage } from '@/features/auth/browser-gate-page'
export const Route = createFileRoute('/browser-gate')({ component: BrowserGatePage })
